<template>
<div class="m-module">
    <div class="section">
        <div class="page-title">
            {{ $t("lang.crypto") }} : {{selectedNet.fullName}}
        </div>
        <div class="body">
            <div class="pane">
                <div class="hd">
                    <div class="steps">
                        <div class="step-item" :class="{active:stepActive==0, done:stepActive>0}">
                            <div class="step-item-line"></div>
                            <div class="step-item-icon">
                                <van-icon v-if="stepActive>0" name="success" />
                                <span v-else class="text">1</span>
                            </div>
                            <div class="step-item-text"> {{ $t("lang.coin") }}</div>
                        </div>
                        <div class="step-item" :class="{active:stepActive==1, done:stepActive>1}">
                            <div class="step-item-line"></div>
                            <div class="step-item-icon">
                                <span v-if="stepActive>1" class="el-icon-check"></span>
                                <span v-else class="text">2</span>
                            </div>
                            <div class="step-item-text">{{ $t("lang.network") }}</div>
                        </div>
                        <div class="step-item" :class="{active:stepActive==2, done:stepActive>2}">
                            <div class="step-item-line"></div>
                            <div class="step-item-icon">
                                <span v-if="stepActive>2" class="el-icon-check"></span>
                                <span v-else class="text">3</span>
                            </div>
                            <div class="step-item-text">{{ $t("lang.address") }}</div>
                        </div>
                    </div>
                </div>
                <div class="bd">
                    <div class="step-content">
                        <div class="step-pane" v-if="stepActive==0">
                            <div class="form-field" @click="coinPopup=true">
                                <el-input  :readonly="true" :placeholder="$t('lang.pleaseCoin')" suffix-icon="el-icon-arrow-right" />
                            </div>
                        </div>
                        <div class="step-pane" v-if="stepActive==1">
                            <div class="form-field" @click="networkPopup=true">
                                <el-input :readonly="true" :placeholder="$t('lang.pleaseNetwork')" suffix-icon="el-icon-arrow-right" />
                            </div>
                        </div>
                        <div class="step-pane" v-if="stepActive==2">
                            <div class="qrcode-container">
                                <div class="qrcode-box">
                                    <!-- <img class="img" :src="require('@/assets/img/qrcode-demo.png')" /> -->
                                    <img class="img" :src="qrcodeUrl" alt="" />
                                </div>
                                <!-- <div class="qrcode-text">
                                    仅支持对该地址充值。<br />
                                    该地址不支持充值NFT,请至NFT页面充值
                                </div> -->
                            </div>
                            <div class="text-group">
                                <div class="text-item">
                                    <div class="item-label">{{selectedCoinData.fullName}} {{ $t("lang.address") }}</div>
                                    <div class="item-val">
                                        <div class="val-text">{{address.address}}</div>
                                        <div class="val-act">
                                            <i class="icon el-icon-copy-document" @click="handleCopy(address.address)"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-item">
                                    <div class="item-label">{{ $t("lang.textNetwork") }}</div>
                                    <div class="item-val">
                                        <div class="val-text">{{selectedNetData.networkName}}</div>
                                        <!-- <div class="val-act">
                                            <i class="icon el-icon-sort"></i>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="metas">
                                <van-cell-group>
                                    <van-cell :title="$t('lang.minimum')" :value="address.minRechargeCoin" />
                                    <!-- <van-cell title="充值区块确认数" value="60 次网络确认" />
                                    <van-cell title="提现解锁确认数" value="900 次网络确认" /> -->
                                </van-cell-group>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
            <div class="card">
                <div class="hd">
                    <h2 class="title">{{ $t("lang.deposit") }}</h2>
                </div>
                <div class="bd">
                    <div class="table-wrapper">
                        <!-- <div class="table-tools">
                            <div class="table-tabs">
                                <div class="tab-item active">数字币地址转账</div>
                                <div class="tab-item">Revolution用户</div>
                            </div>
                        </div> -->
                        <div   class="table-inner"    element-loading-spinner="el-icon-loading"  >
                            <el-table :data="dataSourceList">
                        
                                <el-table-column  :label="$t('lang.address')" prop="thirdFlowNo" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.thirdFlowNo }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('lang.amount')" prop="revoCoin" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.revoCoin }}</span>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column :label="$t('lang.Time')" prop="createTime" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.createTime }}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column :label="$t('lang.ReviewStatus')" prop="auditStateVal" align="center">
                                    <template slot-scope="scope">
                                        <el-tooltip class="item" effect="dark" :content="scope.row.auditReason" placement="top-start">
                                            <span >{{ scope.row.auditStateVal }}</span>
                                        </el-tooltip>
                                    </template>
                                </el-table-column> -->
                                <!-- <el-table-column :label="$t('lang.ReasonReview')" prop="auditReason" align="center">
                                    <template slot-scope="scope">
                                        <span >{{ scope.row.auditReason }}</span>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                            <div class="pagination">
                                <el-pagination
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="ipagination.pageNo"
                                    :page-size="ipagination.pageSize"
                                    layout="prev, pager, next, jumper"
                                    :total="ipagination.total">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
            <!-- <div >
                <div class="cope" v-for="(item, index) in dateLists" :key="'date_'+index" @click="payeeList(item) ">
                    <div>{{ $t("lang.currency") }}：{{item.fullName  }}</div>
                    <div>{{ $t("lang.textNetwork") }}：{{item.networkName  }}</div>
                    <div class="del" @click.stop="deleted(index)">删除</div>
                </div>
            </div> -->
        </div>
        <div class="tabbar-placeholder"></div>
        <div class="tabbar">
            <div class="tabbar-inner u-flex">
                <div class="u-flex-item u-flex-1">
                    <van-button block round @click="returnPrev">{{ $t("lang.ReturnPage") }}</van-button>
                </div>
                <!-- <div :class="stepActive==2?'u-flex-1':'u-flex-item u-flex-1'" v-if="stepActive==1 || stepActive==2">
                    <van-button block round @click="handlePrev">{{ $t("lang.cancel") }}</van-button>
                </div> -->
                <div :class="stepActive==2?'u-flex-item u-flex-2':'u-flex-1'" v-if="stepActive==2">
                    <van-button block round type="primary" @click="account">{{ $t("lang.recharged") }}</van-button>
                </div>
            </div>
        </div>
        
        <!-- <div class="tabbar">
            <div class="tabbar-inner u-flex">
                <div :class="stepActive==2?'u-flex-1':'u-flex-item u-flex-1'" v-if="stepActive==1||stepActive==2">
                    <van-button block round @click="handlePrev">Prev</van-button>
                </div>
                <div :class="stepActive==1?'u-flex-item u-flex-2':'u-flex-1'" v-if="stepActive==1">
                    <van-button block round type="primary" @click="handleNext">Next</van-button>
                </div>
            </div>
        </div> -->
    </div>
    <van-popup v-model="coinPopup" position="bottom" closeable :style="{ height: '50%' }">
        <div class="popup-mod">
            <div class="hd">
                <h3 class="title">{{ $t("lang.coin") }}</h3>
            </div>
            <van-divider />
            <div class="bd">
                <ul class="coins">
                    <li :class="{'active':item.active&&item.enabled,'actives':!item.enabled}"  v-for="(item, index) in coinsDataSource" :key="'coin_'+index"
                        @click="selectCoin(item, index)"
                    >
                        <div class="coin">
                            <div class="item-icon">
                                <img class="img" :src="require('@/assets/img/icon_m_send.svg')" />
                            </div>
                            <div class="item-info">
                                <div class="item-title">{{ item.fullName }}</div>
                                <!-- <div class="item-desc">{{ item.shortName }}</div> -->
                            </div>
                            <div class="item-status">
                                <i class="icon el-icon-check"></i>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="ft">
                <div class="form-action">
                    <van-button round block :disabled="!selectedCoinData.enabled"  type="primary" @click="selectCoinSubmit">{{ $t("lang.submit") }}</van-button>
                </div>
            </div>
        </div>
    </van-popup>
    <van-popup v-model="networkPopup" position="bottom" closeable :style="{ height: '50%' }">
        <div class="popup-mod">
            <div class="hd">
                <h3 class="title">{{ $t("lang.network") }}</h3>
            </div>
            <van-divider />
            <div class="bd">
                <!-- <van-notice-bar wrapable left-icon="info-o">
                    Please note that only supported networks on Revolution platform are shown. If you deposit via another network your assets may be lost.
                </van-notice-bar> -->
                <ul class="networks">
                    <li :class="{'active':item.active&&item.enabled,'actives':!item.enabled}" v-for="(item, index) in networkSource" :key="'net_'+index"
                        @click="selectNet(item, index)">
                        <div class="item">
                            <div class="item-info">
                                <div class="item-title">{{item.networkName}}</div>
                                <!-- <div class="item-desc">Tron(TRC20)</div> -->
                            </div>
                            <div class="item-status">
                                <i class="icon el-icon-check"></i>
                            </div>
                        </div>
                    </li>
                    <!-- <li>
                        <div class="item">
                            <div class="item-info">
                                <div class="item-title">TRX</div>
                                <div class="item-desc">Tron(TRC20)</div>
                            </div>
                            <div class="item-status">
                                <i class="icon el-icon-check"></i>
                            </div>
                        </div>
                    </li> -->
                </ul>
            </div>
            <div class="ft">
                <div class="form-action">
                    <van-button round block :disabled="!selectedNetData.enabled"  type="primary" @click="selectNetSubmit">{{ $t("lang.submit") }}</van-button>
                </div>
            </div>
        </div>
    </van-popup>
    <rechargeWarningDial ref="rechargeWarningDial"></rechargeWarningDial>
</div>
</template>
<script>
import QRCode  from "qrcode";
import Header from "@/components/mobile/header";
import lineChart from "@/views/account/modules/lineChart.vue";
import { Toast } from 'vant';
import {BASE_GLOB_API, BASE_GLOB_DOMAIN} from "@/config.js";
import {axiosGet, axiosPost} from '@/api/api';
import rechargeWarningDial from "@/components/rechargeWarningDial.vue";

export default {
    name:'payment-m',
    components: {
        Header,
        lineChart,
        rechargeWarningDial,
    },
    data(){
        return {
            coinPopup:false,
            networkPopup:false,
            form:{
                verifyCode:''
            },
            url:{
                coins:BASE_GLOB_API+'/kanban/coin/platform',
                payee:BASE_GLOB_API+'/recharge/payee',
                confirm:BASE_GLOB_API+'/recharge/confirm',
                page:BASE_GLOB_API+'/recharge/page',
            },
            stepActive:0,
            coinsDataSource:[],
            selectedCoinData:{},
            networkDataSources:[],
            selectedNetData:{},
            address:{},
            qrcodeUrl:'',
            lang: "",
            dateLists:[],
            networkSource:[],
            selectedNet:{},
            dataSourceList:[],
            ipagination:{
                pageNo:1,
                pageSize:10,
                total:0
            },
        }
    },
    mounted(){
        this.$refs.rechargeWarningDial.openDialog(
            this.selectedNet.fullName, this.$t('lang.rechargeWarning')
        );
    },
    created(){
        this.lang = sessionStorage.getItem("Language")
        // let date = JSON.parse( sessionStorage.getItem("DataList"));
        // if(date){
        //     this.dateLists =date
        //     console.log("this.dateLists",this.dateLists)
        // }
        // this.initData();
        this.selectedNet = JSON.parse( sessionStorage.getItem("selectedNet"));
        console.log("this.selectedNet",this.selectedNet)
        if(this.selectedNet){
            this.stepActive =2
            this.selectDate()
            this.selection(1,10)
        }
    },
    methods:{
        handleSizeChange(val) {
                //console.log(`每页 ${val} 条`);
            },
            handleCurrentChange(val) {
                //console.log(`当前页: ${val}`);
                
                this.selection(val, this.ipagination.pageSize);
            },
        selection(pageNo, pageSize){
          
          let params = {
            query:{
                btPlatformId:this.selectedNetPc.btPlatformId,
            }
            //   walletId:this.selectedNet.id
          };
          axiosPost(this.url.page, params).then(res=>{
              if(res.success){
                let data = res.result;
                this.dataSourceList = data.records;
                this.ipagination.pageNo = Number(data.current);
                this.ipagination.pageSize =Number(data.size);
                this.ipagination.total =Number(data.total);
              }else{
                  this.$message.error(res.message);
              }
          })
      },
        selectDate(){
            let params = {
                btPlatformId:this.selectedNet.btPlatformId,
                btPlatformNetworkId:this.selectedNet.btPlatformNetworkId,
            };
            axiosGet(this.url.payee, params).then(res=>{
               if(res.code ==200){
                  this.address =res.result
                  this.copyList()
                  let self = this;
                    QRCode.toDataURL(
                        this.address.address,
                    { errorCorrectrionLevel: "H", version: 8 },
                    function (err, url) {
                        if (!err) {
                        self.qrcodeUrl = url;
                        }
                    }
                    );
               }else{
                    this.$message.error(res.message);
                }
            }).catch(err=>{
                console.log("coins catch:",err)
            })
        },
        deleted(i){
            this.dateLists.splice(i,1);
            window.sessionStorage.setItem("DataList", JSON.stringify( this.dateLists));
        },
        payeeList(e){
             this.selectedCoinData.id =e.btPlatformId;
             this.selectedNetData.id = e.btPlatformNetworkId;
            let params = {
                btPlatformId:e.btPlatformId,
                btPlatformNetworkId:e.btPlatformNetworkId,
            };
            axiosGet(this.url.payee, params).then(res=>{
               if(res.code ==200){
                  this.address =res.result
                  this.stepActive =2
                  let self = this;
                    QRCode.toDataURL(
                        this.address.address,
                    { errorCorrectrionLevel: "H", version: 8 },
                    function (err, url) {
                        if (!err) {
                        self.qrcodeUrl = url;
                        }
                    }
                );
               }else{
                    this.$message.error(res.message);
                }
            }).catch(err=>{
                console.log("coins catch:",err)
            })
        },
        returnPrev(){
            this.$router.push({name:'dashboard-m'});
        },
        account(){
            let params = {
                btPlatformId:this.selectedNet.btPlatformId,
                btPlatformNetworkId:this.selectedNet.btPlatformNetworkId,
            };
            axiosGet(this.url.confirm, params).then(res=>{
               if(res.code ==200){
                if(res.result){
                    this.$message.success(this.$t("lang.received"));
                    this.$router.push({name:'dashboard-m'});
                }else{
                    this.$message.error(this.$t("lang.notRreceived"));
                }
                
               }
            }).catch(err=>{
                console.log("coins catch:",err)
            })
        },
        handlePrev(){
            this.stepActive--;
            let date = JSON.parse( sessionStorage.getItem("DataList"));
            console.log("this.date",date)
            if(date){
                this.dateLists =date
                console.log("this.dateLists",this.dateLists)
            }
        },
        handleNext(){
            this.stepActive++;
           
        },
        handleCopy(content){
            this.$copyText(content).then(res=>{
                Toast.success(this.$t("lang.replicationSuccessful"))
            },
            err => {
                Toast.fail(this.$t("lang.replicationFailed"))
            })
        },
        initData(){
            let params = {};
            axiosGet(this.url.coins, params).then(res=>{
               if(res.code ==200){
                let data =res.result,dataSource = [],networkDataSource = []
                data.forEach(item=>{
                     let source ={
                        enabled:item.enabled,
                        fullName:item.fullName,
                        icon:item.icon,
                        id:item.id,
                        shortName:item.shortName,
                        active:false
                     }
                    dataSource.push(source);
                    // dataSource=[
                    //     {enabled:true,fullName:123,icon:1,id:123,shortName:123,active:false},
                    //     {enabled:false,fullName:456,icon:1,id:123,shortName:456,active:false}
                    // ]
                    if(item.networkVos){
                        item.networkVos.forEach(item=>{
                            let networkSource ={
                                enabled:item.enabled,
                                btPlatformId:item.btPlatformId,
                                deletedVersion:item.deletedVersion,
                                id:item.id,
                                networkName:item.networkName,
                                networkUrl:item.networkUrl,
                                active:false
                           }
                           networkDataSource.push(networkSource);
                        });
                    }
                });
                this.coinsDataSource = dataSource
                this.networkDataSources = networkDataSource
                console.log("222",this.coinsDataSource)
                console.log("222",this.networkDataSources)
               }
            }).catch(err=>{
                console.log("coins catch:",err)
            })
        },
        selectCoin(obj, index){
          
              this.selectedCoinData={}
              this.coinsDataSource.forEach(item=>{
                item.active = false;
              });
            obj.active = true;
            this.selectedCoinData = obj;
            console.log("2",this.selectedCoinData)
            let coinId = this.selectedCoinData.id, flag = false;
                this.dateLists =[]
                this.networkSource=[]
				this.networkDataSources.forEach(item=>{
					if(coinId == item.btPlatformId){
						let sourceList ={
                        enabled:item.enabled,
                        btPlatformId:item.btPlatformId,
                        deletedVersion:item.deletedVersion,
                        id:item.id,
                        networkName:item.networkName,
                        networkUrl:item.networkUrl,
                        active:false
                    }
                    this.networkSource.push(sourceList)
					}
				})
        
            	
        },
        selectNet(obj, index){
              this.selectedNetData={}
              this.networkDataSources.forEach(item=>{
                item.active = false;
            });
            obj.active = true;
            this.selectedNetData = obj;
            console.log("21",this.selectedNetData)
        },
        selectCoinSubmit(){
            if(this.selectedCoinData.fullName){
                this.stepActive =1
                this.coinPopup =false
            }else{
                this.coinPopup =false
            }
        },
        selectNetSubmit(){
            if(this.selectedNetData.networkName){
                this.stepActive =2
                this.payee()
                this.networkPopup =false
            }else{
                this.networkPopup =false
            }
        },
        payee(){
            let params = {
                btPlatformId:this.selectedCoinData.id,
                btPlatformNetworkId:this.selectedNetData.id,
            };
            axiosGet(this.url.payee, params).then(res=>{
               if(res.code ==200){
                  this.address =res.result
                  this.copyList()
                  let self = this;
                    QRCode.toDataURL(
                        this.address.address,
                    { errorCorrectrionLevel: "H", version: 8 },
                    function (err, url) {
                        if (!err) {
                        self.qrcodeUrl = url;
                        }
                    }
                    );
               }else{
                    this.$message.error(res.message);
                }
            }).catch(err=>{
                console.log("coins catch:",err)
            })
        },
        copyList(){
               let btPlatformId = this.selectedCoinData.id,btPlatformNetworkId = this.selectedNetData.id, flag = false;
				this.dateLists.forEach(item=>{
					if((btPlatformId == item.btPlatformId)&&(btPlatformNetworkId == item.btPlatformNetworkId)){
						flag = true;
					}
				})
				if(!flag) {
                    let sourceList ={
                        btPlatformId:this.selectedCoinData.id,
                        btPlatformNetworkId:this.selectedNetData.id,
                        fullName:this.selectedCoinData.fullName,
                        networkName:this.selectedNetData.networkName,
                    }
                    this.dateLists.push(sourceList)
                    window.sessionStorage.setItem("DataList", JSON.stringify( this.dateLists));
				}
           
        }
    }
}
</script>
<style lang="less" scoped>
.m-module {
    .section {
        .page-title {
            font-size:20px; font-weight:600; padding:30px 15px;
        }
        .pane {
            background:#fff; padding:15px;
            .hd {
                padding:0 0 15px;
            }
            .bd {
                .step-content {
                    .step-pane {
                        .qrcode-container {
                            .qrcode-box {
                                width:300px; height:300px; margin:0 auto;
                                .img {
                                    width:100%; height:100%; display:block;
                                }
                            }
                            .qrcode-text {
                                text-align:center; font-size:14px;
                            }
                        }
                        .text-group {
                            .text-item {
                                border-bottom:#e6e6e6 1px solid; padding:10px 0;
                                .item-label {
                                    font-size:14px; padding:0 0 6px;
                                }
                                .item-val {
                                    display:flex; justify-content: space-between; align-items: flex-start;
                                    .val-text {
                                        font-size:12px; font-weight:600;
                                    }
                                    .val-act {
                                        width:24px; min-width:24px; text-align:right;
                                        .icon {
                                            font-size:14px; color:#4857f5;
                                            &.el-icon-sort {
                                                transform: rotate(90deg);
                                            }
                                        }
                                    }
                                }
                                &:last-child {border-bottom: 0;}
                            }
                        }
                        .metas {
                            margin:20px 0 0; background:#f4f5f6; border-radius:4px;
                            .van-cell-group {
                                background:transparent;
                                .van-cell {background: transparent;}
                            }
                        }
                    }
                }
            }
        }
        .card {
            padding: 30px 0;
            .hd {
                .title {}
            }
            .bd {
                .table-wrapper {
                    padding:10px 0;
                    .table-tools {
                        .table-tabs {
                            display:flex; justify-content: flex-start; align-items: center;
                            .tab-item {
                                line-height:1; padding:8px 14px; border-radius:4px; background:#f4f5f6; margin:0 10px 10px 0; cursor: pointer;
                                &.active, &:hover {
                                    background:#e7eafe; color:#4458fe;
                                }
                            }
                        }
                    }
                    .table-inner{
                        .pagination {
                            padding:15px 0; text-align:right;
                        }
                    }
                }
            }
 }
        .cope{
            border-radius: 2em;
            margin: 10px 10px 0 10px;
            padding: 15px 10px;
            display: flex;
            justify-content: space-around;
            background-color: #fff;
            .del{
                color: red;
            }
        }
    }
}
.steps {
    display:flex; justify-content: space-between; align-items: center;
    .step-item {
        position:relative; flex:1;
        .step-item-line {
            height:2px; background:#c0c4cc; position:absolute; left:0; right:0; top:10px;
        }
        .step-item-icon {
            width:20px; height:20px; font-size:12px; margin:0 auto; border-radius:50%; border:#c0c4cc 2px solid; display:flex; justify-content: center; align-items: center; background:#fff; color:#c0c4cc; position:relative; z-index:1;
            .el-icon-check {
                font-weight:700;
            }
        }
        .step-item-text {
            font-weight:600; padding:8px 0 10px; color:#c0c4cc; text-align: center;
        }
        &:first-child {
            .step-item-line {left:50%;}
        }
        &:last-child {
            .step-item-line {right:50%;}
        }
        &.active{
            .step-item-icon {border-color:#333; color:#333;}
            .step-item-text {color:#333;}
        }
         &.done {
            .step-item-icon {color:#fff; background:#44ac30; border-color:#44ac30;}
            .step-item-text {color:#44ac30;}
        }
    }
}
.popup-mod {
    height:100%; position:relative; overflow: hidden;
    .hd {
        padding:16px 16px;
        .title {
            font-size:16px; font-weight:700;
        }
    }
    .van-divider {margin:0;}
    .bd {
        position:absolute; top:52px; left:0; right:0; bottom:54px; overflow:auto;
        .coins {
            padding:10px;
            &>li {
                border-bottom:#e6e6e6 1px solid;
                .coin {
                    display:flex; justify-content: space-between; align-items: center; padding:10px 15px;
                    .item-icon {
                        width:32px; height:32px; min-width:32px;
                        .img {width:100%; height:100%; border-radius:50%;}
                    }
                    .item-info {
                        padding:0 10px; flex:1; text-align:left;
                        .item-title {
                            font-weight:600; color:#333;
                        }
                        .item-desc {
                            color:#999; font-size:12px;
                        }
                    }
                    .item-status {
                        display:flex; justify-content: flex-end; align-items: center;
                        .icon {display:none;}
                    }
                }
                &.active {
                    .coin {
                        background:#e8eafc; color:#4857f5; border-radius:4px;
                        .item-status {
                            .icon {color:#44ac30; display:block;}
                        }
                    }
                }
                &.actives {
                    .coin {
                        background:#DCDCDC; color:#DCDCDC; border-radius:4px;
                        .item-status {
                            .icon {color:#DCDCDC; display:block;}
                        }
                        .item-info {
                            padding:0 10px; flex:1; text-align:left;
                        .item-title {
                            font-weight:600; color:#999;
                        }
                        .item-desc {
                            color:#999; font-size:12px;
                        }
                    }
                        
                    }
                }
            }
        }
        .networks {
            &>li {
                padding:3px 10px;
                .item {
                     border-radius:4px; display:flex; justify-content: space-between; align-items: center; padding:10px;
                    .item-info {
                        flex:1; color:#333;
                        .item-title {
                            font-size:16px; font-weight:600;
                        }
                        .item-desc {
                            opacity: .5;
                        }
                    }
                    .item-status {
                        display:flex; justify-content: center; align-items: center;
                        .icon {display:none;}
                    }
                }
                &.active {
                    .item {
                        background:#e8eafc; color:#4857f5;
                        .item-info {
                            color:#4857f5;
                        }
                        .item-status {
                            .icon {display:block;}
                        }
                    }
                }
                &.actives {
                    .item {
                        background:#DCDCDC; color:#DCDCDC;
                        .item-info {
                            color:#999;
                        }
                        .item-status {
                            .icon {display:block;}
                        }
                    }
                }
            }
        }
    }
    .ft {
        position:absolute; z-index:1; left:0; bottom:0; right:0; height:54px;
        .form-action {
            padding:5px 16px;
        }
    }
}
.tabbar-placeholder {
    height:54px;
}
.tabbar {
    position:fixed; left:0; bottom:0; right:0; height:54px; background:#fff; box-shadow:0 0 8px rgba(0,0,0,.08);
    .tabbar-inner {
        padding:5px 15px;
        &.u-flex {
            display:flex; justify-content: space-between; align-items: center;
            .u-flex-item {
                &:first-child {margin-right:7px;}
                &:last-child {margin-left:8px;}
            }
            .u-flex-1 {
                flex:1;
            }
            .u-flex-2 {
                flex:2;
            }
        }
    }
}
</style>